export const ENV = 'staging'; //dev | production | staging
